module.exports = __webpack_public_path__ + "static/lightning-table-header-icons-bb015bc97f640e1c32ef4d9696c9c7b7.png";